import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { toTitleCase } from '@shared/utils/strings';

@Pipe({ name: 'title' })
export class TitlePipe implements PipeTransform {

    transform(value: string | string[]): any {
        if (!value) {
            return value;
        }

        if (Array.isArray(value)) {
            return value.map(v => toTitleCase(v));
        }

        return toTitleCase(value);
    }

}
